/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Cognito API
 * Bank Relationship Management - Cognito
 * OpenAPI spec version: v1
 */
import type {
  GetApiV1DashboardAvailableVsContractedCredit200,
  GetApiV1DashboardAvailableVsContractedCreditParams,
  GetApiV1DashboardCalendar200,
  GetApiV1DashboardCalendarParams,
  GetApiV1DashboardCurrencyQuotesAll200,
  GetApiV1DashboardDerivativeIndex200,
  GetApiV1DashboardDerivativeIndexParams,
  GetApiV1DashboardEconomicCalendar200,
  GetApiV1DashboardEconomicCalendarParams,
  GetApiV1DashboardIndexesBmfCupomCambial200,
  GetApiV1DashboardIndexesBmfCupomCambialParams,
  GetApiV1DashboardIndexesBmfDiPre200,
  GetApiV1DashboardIndexesBmfDiPreInterpolatedRate200,
  GetApiV1DashboardIndexesBmfDiPreInterpolatedRateParams,
  GetApiV1DashboardIndexesBmfDiPreParams,
  GetApiV1DashboardIndexesBmfDiVsIpca200,
  GetApiV1DashboardIndexesBmfDiVsIpcaInterpolatedRate200,
  GetApiV1DashboardIndexesBmfDiVsIpcaInterpolatedRateParams,
  GetApiV1DashboardIndexesBmfDiVsIpcaParams,
  GetApiV1DashboardIndexesBmfDolarXPre200,
  GetApiV1DashboardIndexesBmfDolarXPreParams,
  GetApiV1DashboardIndexesCdiDaily200,
  GetApiV1DashboardIndexesCdiDailyAnnualizedCurrent200,
  GetApiV1DashboardIndexesCdiDailyCurrent200,
  GetApiV1DashboardIndexesCdiDailyParams,
  GetApiV1DashboardIndexesCurrencyExchangeCurrent200,
  GetApiV1DashboardIndexesDapCurve200,
  GetApiV1DashboardIndexesDapCurveInterpolatedRate200,
  GetApiV1DashboardIndexesDapCurveInterpolatedRateParams,
  GetApiV1DashboardIndexesDapCurveParams,
  GetApiV1DashboardIndexesDdiCurve200,
  GetApiV1DashboardIndexesDdiCurveInterpolatedRate200,
  GetApiV1DashboardIndexesDdiCurveInterpolatedRateParams,
  GetApiV1DashboardIndexesDdiCurveParams,
  GetApiV1DashboardIndexesDi1Curve200,
  GetApiV1DashboardIndexesDi1CurveInterpolatedRate200,
  GetApiV1DashboardIndexesDi1CurveInterpolatedRateParams,
  GetApiV1DashboardIndexesDi1CurveParams,
  GetApiV1DashboardIndexesDolCurve200,
  GetApiV1DashboardIndexesDolCurveInterpolatedRate200,
  GetApiV1DashboardIndexesDolCurveInterpolatedRateParams,
  GetApiV1DashboardIndexesDolCurveParams,
  GetApiV1DashboardIndexesDollarVolatilitySurface200,
  GetApiV1DashboardIndexesDollarVolatilitySurfaceParams,
  GetApiV1DashboardIndexesEurCurve200,
  GetApiV1DashboardIndexesEurCurveInterpolatedRate200,
  GetApiV1DashboardIndexesEurCurveInterpolatedRateParams,
  GetApiV1DashboardIndexesEurCurveParams,
  GetApiV1DashboardIndexesForward200,
  GetApiV1DashboardIndexesForwardParams,
  GetApiV1DashboardIndexesImplicitIpcaCurve200,
  GetApiV1DashboardIndexesImplicitIpcaCurveInterpolatedRate200,
  GetApiV1DashboardIndexesImplicitIpcaCurveInterpolatedRateParams,
  GetApiV1DashboardIndexesImplicitIpcaCurveParams,
  GetApiV1DashboardIndexesIpcaMonth200,
  GetApiV1DashboardIndexesIpcaMonthCurrent200,
  GetApiV1DashboardIndexesIpcaMonthParams,
  GetApiV1DashboardIndexesSofrCurrent200,
  GetApiV1DashboardKeyIndicators200,
  GetApiV1DashboardKeyIndicatorsParams,
  GetApiV1DashboardPtaxCurveLast60Days200
} from '../schemas';

import { customInstance } from '.././mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getDashboard = () => {
const getDashboardAvailableVsContractedCredit = (
    params?: GetApiV1DashboardAvailableVsContractedCreditParams,
 options?: SecondParameter<typeof customInstance<GetApiV1DashboardAvailableVsContractedCredit200>>,) => {
      return customInstance<GetApiV1DashboardAvailableVsContractedCredit200>(
      {url: `/api/v1/dashboard/available-vs-contracted-credit`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Obt�m o valor anualizado atual do CDI (Certificado de Dep�sito Interbanc�rio).
 */
const getDashboardIndexesCdiDailyAnnualizedCurrent = (

 options?: SecondParameter<typeof customInstance<GetApiV1DashboardIndexesCdiDailyAnnualizedCurrent200>>,) => {
      return customInstance<GetApiV1DashboardIndexesCdiDailyAnnualizedCurrent200>(
      {url: `/api/v1/dashboard/indexes/cdi-daily-annualized/current`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Obt�m o valor atual do CDI (Certificado de Dep�sito Interbanc�rio).
 */
const getDashboardIndexesCdiDailyCurrent = (

 options?: SecondParameter<typeof customInstance<GetApiV1DashboardIndexesCdiDailyCurrent200>>,) => {
      return customInstance<GetApiV1DashboardIndexesCdiDailyCurrent200>(
      {url: `/api/v1/dashboard/indexes/cdi-daily/current`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Obt�m o CDI di�rio realizado em um per�odo espec�fico.
 */
const getDashboardIndexesCdiDaily = (
    params?: GetApiV1DashboardIndexesCdiDailyParams,
 options?: SecondParameter<typeof customInstance<GetApiV1DashboardIndexesCdiDaily200>>,) => {
      return customInstance<GetApiV1DashboardIndexesCdiDaily200>(
      {url: `/api/v1/dashboard/indexes/cdi-daily`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Obt�m o valor atual do SOFR (Secured Overnight Financing Rate).
 */
const getDashboardIndexesSofrCurrent = (

 options?: SecondParameter<typeof customInstance<GetApiV1DashboardIndexesSofrCurrent200>>,) => {
      return customInstance<GetApiV1DashboardIndexesSofrCurrent200>(
      {url: `/api/v1/dashboard/indexes/sofr/current`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Obt�m o valor acumulado atual do IPCA (�ndice Nacional de Pre�os ao Consumidor Amplo).
 */
const getDashboardIndexesIpcaMonthCurrent = (

 options?: SecondParameter<typeof customInstance<GetApiV1DashboardIndexesIpcaMonthCurrent200>>,) => {
      return customInstance<GetApiV1DashboardIndexesIpcaMonthCurrent200>(
      {url: `/api/v1/dashboard/indexes/ipca-month/current`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Obt�m a s�rie hist�rica mensal do IPCA para um per�odo espec�fico.
 */
const getDashboardIndexesIpcaMonth = (
    params?: GetApiV1DashboardIndexesIpcaMonthParams,
 options?: SecondParameter<typeof customInstance<GetApiV1DashboardIndexesIpcaMonth200>>,) => {
      return customInstance<GetApiV1DashboardIndexesIpcaMonth200>(
      {url: `/api/v1/dashboard/indexes/ipca-month`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Obt�m as informa��es atuais de c�mbio para USD/BRL e EUR/BRL.
 */
const getDashboardIndexesCurrencyExchangeCurrent = (

 options?: SecondParameter<typeof customInstance<GetApiV1DashboardIndexesCurrencyExchangeCurrent200>>,) => {
      return customInstance<GetApiV1DashboardIndexesCurrencyExchangeCurrent200>(
      {url: `/api/v1/dashboard/indexes/currency-exchange/current`, method: 'GET'
    },
      options);
    }
  /**
 * Funcionamento:
1. O m�todo aceita uma data de in�cio e uma data de fim como par�metros, definindo o intervalo de busca dos eventos.
2. Ele consulta o servi�o de calend�rio para recuperar todos os eventos que ocorram dentro do per�odo especificado.
3. Os eventos s�o organizados e agrupados por data, facilitando a an�lise das atividades planejadas para cada dia.
4. Cada evento cont�m um campo 'type' que identifica a natureza espec�fica do evento, como 'derivative' para opera��es de derivativos.

Tipos de Eventos:
- Atualmente, o sistema foca em eventos relacionados a opera��es de derivativos, marcados pelo 'type' 'derivative'.
- A arquitetura do campo 'type' foi projetada para ser extens�vel, permitindo a introdu��o de novos tipos de eventos
  conforme as necessidades do neg�cio evoluem.

Estrutura Flex�vel:
- A estrutura deste m�todo e sua interface s�o flex�veis, permitindo a adi��o de novos tipos de eventos no futuro
  sem a necessidade de altera��es significativas na API.
- Cada novo tipo de evento pode ser acompanhado por uma estrutura de dados espec�fica, assegurando que a API possa
  se adaptar a diferentes cen�rios de neg�cio.

Usabilidade:
Este endpoint � especialmente �til para gestores financeiros e outros profissionais que precisam de uma vis�o r�pida
e consolidada das opera��es e eventos cr�ticos dentro de um per�odo espec�fico. A flexibilidade do sistema garante
que ele possa ser facilmente adaptado para atender novas demandas e incorporar novos tipos de eventos financeiros.
 * @summary Obt�m os eventos do calend�rio para um per�odo espec�fico.

Este m�todo retorna uma lista detalhada de dias com eventos programados, incluindo opera��es de derivativos
e outros eventos financeiros relevantes. Cada dia pode conter m�ltiplos eventos, oferecendo uma vis�o consolidada
das atividades previstas para o per�odo especificado.
 */
const getDashboardCalendar = (
    params?: GetApiV1DashboardCalendarParams,
 options?: SecondParameter<typeof customInstance<GetApiV1DashboardCalendar200>>,) => {
      return customInstance<GetApiV1DashboardCalendar200>(
      {url: `/api/v1/dashboard/calendar`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Este m�todo retorna um conjunto de dados representando o �ndice de derivativos,
cobrindo um per�odo especificado pelo usu�rio (padr�o de 12 meses se n�o informado).
O �ndice fornece uma vis�o consolidada das opera��es de derivativos ao longo do tempo.

Funcionamento:
1. O m�todo aceita um par�metro opcional 'month' para especificar o n�mero de meses a serem analisados.
2. Recupera dados agregados das opera��es de derivativos para o per�odo especificado.
3. Os dados s�o processados para calcular o �ndice mensal de derivativos.
4. O resultado � retornado em um formato adequado para visualiza��o gr�fica.

Estrutura dos Dados:
- O resultado inclui dois conjuntos principais de dados:
  a) Labels: Representando os meses (ex: "Jan/23", "Fev/23", etc.)
  b) Values: Os valores correspondentes do �ndice para cada m�s

Usabilidade:
Este endpoint � particularmente �til para analistas financeiros, gestores de risco e outros
profissionais que necessitam de uma vis�o hist�rica e tend�ncias das opera��es de derivativos.
A flexibilidade de escolher o n�mero de meses permite an�lises customizadas para diferentes per�odos.

Flexibilidade:
- O par�metro 'month' permite que os usu�rios especifiquem o per�odo desejado para an�lise.
- Futuros aprimoramentos podem incluir filtros adicionais ou op��es de agrega��o.
 * @summary Obt�m o �ndice de derivativos para um n�mero espec�fico de meses.
 */
const getDashboardDerivativeIndex = (
    params?: GetApiV1DashboardDerivativeIndexParams,
 options?: SecondParameter<typeof customInstance<GetApiV1DashboardDerivativeIndex200>>,) => {
      return customInstance<GetApiV1DashboardDerivativeIndex200>(
      {url: `/api/v1/dashboard/derivative-index`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Este m�todo retorna uma lista de eventos econ�micos para o per�odo especificado.
O calend�rio econ�mico fornece uma vis�o geral dos principais eventos econ�micos que podem impactar os mercados financeiros.
 * @summary Obt�m o calend�rio econ�mico para um intervalo de datas especificado.
 */
const getDashboardEconomicCalendar = (
    params?: GetApiV1DashboardEconomicCalendarParams,
 options?: SecondParameter<typeof customInstance<GetApiV1DashboardEconomicCalendar200>>,) => {
      return customInstance<GetApiV1DashboardEconomicCalendar200>(
      {url: `/api/v1/dashboard/economic-calendar`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Retorna uma lista de cota��es das principais moedas em rela��o ao real.
 * @summary Obt�m as cota��es de todas as moedas suportadas.
 */
const getDashboardCurrencyQuotesAll = (

 options?: SecondParameter<typeof customInstance<GetApiV1DashboardCurrencyQuotesAll200>>,) => {
      return customInstance<GetApiV1DashboardCurrencyQuotesAll200>(
      {url: `/api/v1/dashboard/currency-quotes/all`, method: 'GET'
    },
      options);
    }
  /**
 * A p�gina p�blica da B3 para consulta visual do contrato `DI1` �:
`https://www.b3.com.br/pt_br/market-data-e-indices/servicos-de-dados/market-data/cotacoes/mercado-de-derivativos/?symbol=DI1`

Este endpoint consome a API JSON oficial da B3 para o contrato `DI1`:
`https://cotacao.b3.com.br/mds/api/v1/DerivativeQuotation/DI1`

A resposta do backend exp�e a data da �ltima atualiza��o em cache (`LastUpdate`) e a lista de vencimentos dispon�veis em `Quotes`.
Cada item da curva representa um contrato DI1 retornado pela B3, incluindo data de vencimento e �ltimo pre�o negociado.

Este endpoint n�o faz scraping de HTML. A origem � diretamente o endpoint JSON de cota��es da B3, no mesmo padr�o utilizado para outras curvas modernas como `DDI` e `DAP`.
 * @summary Obt�m a curva do DI1 com vencimentos, quantidade de dias at� o vencimento e os principais campos de cota��o retornados pela B3.
 */
const getDashboardIndexesDi1Curve = (
    params?: GetApiV1DashboardIndexesDi1CurveParams,
 options?: SecondParameter<typeof customInstance<GetApiV1DashboardIndexesDi1Curve200>>,) => {
      return customInstance<GetApiV1DashboardIndexesDi1Curve200>(
      {url: `/api/v1/dashboard/indexes/di1-curve`, method: 'GET',
        params
    },
      options);
    }
  /**
 * A p�gina p�blica da B3 para consulta visual do contrato `DDI` �:
`https://www.b3.com.br/pt_br/market-data-e-indices/servicos-de-dados/market-data/cotacoes/mercado-de-derivativos/?symbol=DDI`

Este endpoint consome a API JSON oficial da B3 para o contrato `DDI`:
`https://cotacao.b3.com.br/mds/api/v1/DerivativeQuotation/DDI`

A resposta do backend exp�e a data da �ltima atualiza��o em cache (`LastUpdate`) e a lista de contratos em `Quotes`.
Cada item da curva cont�m os dados principais que a B3 publica para o vencimento, como quantidade de contratos em aberto,
n�mero de neg�cios, volume, pre�os de abertura, m�nima, m�xima, m�dia, �ltimo pre�o, ofertas e limites.

Este endpoint n�o depende de scraping da p�gina p�blica. A origem � diretamente o endpoint JSON de cota��es da B3.
 * @summary Obt�m a curva do DDI com vencimentos, dias at� o vencimento e os principais campos de cota��o retornados pela B3.
 */
const getDashboardIndexesDdiCurve = (
    params?: GetApiV1DashboardIndexesDdiCurveParams,
 options?: SecondParameter<typeof customInstance<GetApiV1DashboardIndexesDdiCurve200>>,) => {
      return customInstance<GetApiV1DashboardIndexesDdiCurve200>(
      {url: `/api/v1/dashboard/indexes/ddi-curve`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Este endpoint consome a API JSON oficial da B3 para o contrato `DAP`:
`https://cotacao.b3.com.br/mds/api/v1/DerivativeQuotation/DAP`

A p�gina p�blica da B3 para Cupom de IPCA �:
`https://www.b3.com.br/pt_br/produtos-e-servicos/negociacao/juros/cotacoes-de-cupom-de-ipca.htm`

Essa p�gina p�blica embute um boletim legado, mas tamb�m consome o endpoint JSON acima. O backend usa a fonte JSON diretamente,
sem scraping de HTML, para devolver uma resposta mais est�vel e consistente com os endpoints de `DI1` e `DDI`.

A resposta do backend exp�e a data da �ltima atualiza��o em cache (`LastUpdate`) e a lista de contratos DAP em `Quotes`.
Cada item cont�m os dados principais publicados pela B3 para o vencimento, como contratos em aberto, n�mero de neg�cios,
volume, pre�os de abertura, m�nima, m�xima, m�dia, �ltimo pre�o, ofertas e limites.
 * @summary Obt�m a curva do DAP (Cupom de IPCA) com vencimentos, dias at� o vencimento e os principais campos de cota��o retornados pela B3.
 */
const getDashboardIndexesDapCurve = (
    params?: GetApiV1DashboardIndexesDapCurveParams,
 options?: SecondParameter<typeof customInstance<GetApiV1DashboardIndexesDapCurve200>>,) => {
      return customInstance<GetApiV1DashboardIndexesDapCurve200>(
      {url: `/api/v1/dashboard/indexes/dap-curve`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Este endpoint consome a API JSON oficial da B3 para o contrato `EUR`:
`https://cotacao.b3.com.br/mds/api/v1/DerivativeQuotation/EUR`

A resposta do backend exp�e a data da �ltima atualiza��o em cache (`LastUpdate`) e a lista de contratos em `Quotes`.
Cada item cont�m os campos realmente observados no payload atual da B3 para esse contrato:
s�mbolo, descri��o, c�digo de mercado, vencimento, contratos em aberto, ajuste anterior e limites.

Este endpoint n�o depende de scraping de HTML. A origem � diretamente o endpoint JSON de cota��es da B3.
 * @summary Obt�m a curva do EUR com vencimentos, dias at� o vencimento e os principais campos de cota��o retornados pela B3.
 */
const getDashboardIndexesEurCurve = (
    params?: GetApiV1DashboardIndexesEurCurveParams,
 options?: SecondParameter<typeof customInstance<GetApiV1DashboardIndexesEurCurve200>>,) => {
      return customInstance<GetApiV1DashboardIndexesEurCurve200>(
      {url: `/api/v1/dashboard/indexes/eur-curve`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Este endpoint consome a API JSON oficial da B3 para o contrato `DOL`:
`https://cotacao.b3.com.br/mds/api/v1/DerivativeQuotation/DOL`

O payload da B3 mistura contratos futuros, op��es e spot. Este endpoint exp�e somente os itens com `mkt.cd = FUT`,
que s�o os v�rtices v�lidos da curva futura de d�lar comercial.

A resposta do backend exp�e a data da �ltima atualiza��o em cache (`LastUpdate`) e a lista de contratos futuros em `Quotes`.
Cada item cont�m os campos reais observados no payload para futuros: vencimento, contratos em aberto, neg�cios, volume,
pre�os de abertura, m�nima, m�xima, m�dia, �ltimo pre�o, ofertas, ajuste anterior e limites, quando dispon�veis.
 * @summary Obt�m a curva do DOL com vencimentos, dias at� o vencimento e os principais campos de cota��o dos contratos futuros retornados pela B3.
 */
const getDashboardIndexesDolCurve = (
    params?: GetApiV1DashboardIndexesDolCurveParams,
 options?: SecondParameter<typeof customInstance<GetApiV1DashboardIndexesDolCurve200>>,) => {
      return customInstance<GetApiV1DashboardIndexesDolCurve200>(
      {url: `/api/v1/dashboard/indexes/dol-curve`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Este endpoint usa a API JSON oficial da B3 para `DDI`:
`https://cotacao.b3.com.br/mds/api/v1/DerivativeQuotation/DDI`

A resposta inclui os dois v�rtices da curva usados no c�lculo, o modo de interpola��o aplicado
e os fatores anual e di�rio equivalentes para facilitar a rastreabilidade do valor retornado.
A interpola��o � feita sobre o `LastPrice` dos contratos, usando `MaturityDate` como eixo da curva.
 * @summary Obt�m a taxa anual interpolada da curva DDI para uma data alvo.
 */
const getDashboardIndexesDdiCurveInterpolatedRate = (
    params?: GetApiV1DashboardIndexesDdiCurveInterpolatedRateParams,
 options?: SecondParameter<typeof customInstance<GetApiV1DashboardIndexesDdiCurveInterpolatedRate200>>,) => {
      return customInstance<GetApiV1DashboardIndexesDdiCurveInterpolatedRate200>(
      {url: `/api/v1/dashboard/indexes/ddi-curve/interpolated-rate`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Este endpoint usa a API JSON oficial da B3 para `DOL`:
`https://cotacao.b3.com.br/mds/api/v1/DerivativeQuotation/DOL`

O payload da B3 mistura futuros, op��es e spot. A interpola��o considera somente os contratos com `mkt.cd = FUT`.

A resposta inclui os dois v�rtices da curva usados no c�lculo, o modo de interpola��o aplicado,
a regra de pre�o usada em cada ponto e os fatores anual e di�rio equivalentes para rastreabilidade do valor retornado.
A interpola��o � feita por `MaturityDate`, usando `curPrc` quando dispon�vel e fallback para `prvsDayAdjstmntPric`.
 * @summary Obt�m a taxa anual interpolada da curva DOL para uma data alvo.
 */
const getDashboardIndexesDolCurveInterpolatedRate = (
    params?: GetApiV1DashboardIndexesDolCurveInterpolatedRateParams,
 options?: SecondParameter<typeof customInstance<GetApiV1DashboardIndexesDolCurveInterpolatedRate200>>,) => {
      return customInstance<GetApiV1DashboardIndexesDolCurveInterpolatedRate200>(
      {url: `/api/v1/dashboard/indexes/dol-curve/interpolated-rate`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Este endpoint usa a API JSON oficial da B3 para `DAP`:
`https://cotacao.b3.com.br/mds/api/v1/DerivativeQuotation/DAP`

A p�gina p�blica da B3 relacionada �:
`https://www.b3.com.br/pt_br/produtos-e-servicos/negociacao/juros/cotacoes-de-cupom-de-ipca.htm`

A resposta inclui os dois v�rtices da curva usados no c�lculo, o modo de interpola��o aplicado
e os fatores anual e di�rio equivalentes para facilitar a rastreabilidade do valor retornado.
A interpola��o � feita sobre `prvsDayAdjstmntPric`, usando `MaturityDate` como eixo da curva.
 * @summary Obt�m a taxa anual interpolada da curva DAP (Cupom de IPCA) para uma data alvo.
 */
const getDashboardIndexesDapCurveInterpolatedRate = (
    params?: GetApiV1DashboardIndexesDapCurveInterpolatedRateParams,
 options?: SecondParameter<typeof customInstance<GetApiV1DashboardIndexesDapCurveInterpolatedRate200>>,) => {
      return customInstance<GetApiV1DashboardIndexesDapCurveInterpolatedRate200>(
      {url: `/api/v1/dashboard/indexes/dap-curve/interpolated-rate`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Este endpoint usa a API JSON oficial da B3 para `EUR`:
`https://cotacao.b3.com.br/mds/api/v1/DerivativeQuotation/EUR`

A resposta inclui os dois v�rtices da curva usados no c�lculo, o modo de interpola��o aplicado
e os fatores anual e di�rio equivalentes para facilitar a rastreabilidade do valor retornado.
A interpola��o � feita sobre o `LastPrice` dos contratos, usando `MaturityDate` como eixo da curva.
 * @summary Obt�m a taxa anual interpolada da curva EUR para uma data alvo.
 */
const getDashboardIndexesEurCurveInterpolatedRate = (
    params?: GetApiV1DashboardIndexesEurCurveInterpolatedRateParams,
 options?: SecondParameter<typeof customInstance<GetApiV1DashboardIndexesEurCurveInterpolatedRate200>>,) => {
      return customInstance<GetApiV1DashboardIndexesEurCurveInterpolatedRate200>(
      {url: `/api/v1/dashboard/indexes/eur-curve/interpolated-rate`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Obt�m a curva de PTAX dos �ltimos 60 dias para todas as moedas dispon�veis.
 */
const getDashboardPtaxCurveLast60Days = (

 options?: SecondParameter<typeof customInstance<GetApiV1DashboardPtaxCurveLast60Days200>>,) => {
      return customInstance<GetApiV1DashboardPtaxCurveLast60Days200>(
      {url: `/api/v1/dashboard/ptax-curve-last-60-days`, method: 'GET'
    },
      options);
    }
  /**
 * Este endpoint usa a fonte legada da antiga BMF, acessada via HTML em:
`https://www2.bmf.com.br/pages/portal/bmfbovespa/boletim1/TxRef1.asp`

Diferente dos endpoints modernos que consomem a API JSON da B3 (`cotacao.b3.com.br/mds/api/v1/...`),
este endpoint depende de scraping da p�gina legada `TxRef1.asp`, com o par�metro `slcTaxa` correspondente ao tipo solicitado.

Links de refer�ncia da fonte legada por tipo:
Utilize o par�metro `cupomType` para especificar qual curva deseja obter:
- **CupomLimpo** (`DOC`): `https://www2.bmf.com.br/pages/portal/bmfbovespa/boletim1/TxRef1.asp?slcTaxa=DOC`
- **CupomCambialOC1** (`DCO`): `https://www2.bmf.com.br/pages/portal/bmfbovespa/boletim1/TxRef1.asp?slcTaxa=DCO`
- **CupomCambialSujo** (`DOL`): `https://www2.bmf.com.br/pages/portal/bmfbovespa/boletim1/TxRef1.asp?slcTaxa=DOL`
- **CupomCambialEuro** (`EUC`): `https://www2.bmf.com.br/pages/portal/bmfbovespa/boletim1/TxRef1.asp?slcTaxa=EUC`
- **SpreadLiborEuroDolar** (`SDE`): `https://www2.bmf.com.br/pages/portal/bmfbovespa/boletim1/TxRef1.asp?slcTaxa=SDE`
- **AjusteCupom** (`ACC`): `https://www2.bmf.com.br/pages/portal/bmfbovespa/boletim1/TxRef1.asp?slcTaxa=ACC`
- **RealVsDolar** (`PTX`): `https://www2.bmf.com.br/pages/portal/bmfbovespa/boletim1/TxRef1.asp?slcTaxa=PTX`
- **RealVsEuro** (`EUR`): `https://www2.bmf.com.br/pages/portal/bmfbovespa/boletim1/TxRef1.asp?slcTaxa=EUR`

Observa��o importante: essa fonte legada deixou de ser atualizada ap�s `09/04/2026`.
Por isso, para qualquer `referenceDate` posterior, o backend aplica fallback autom�tico para `09/04/2026`,
preservando o acesso � �ltima curva dispon�vel nessa origem.
 * @summary Obt�m os dados da curva "Cupom Cambial" da BMF para uma data e tipo de cupom espec�ficos.
 */
const getDashboardIndexesBmfCupomCambial = (
    params?: GetApiV1DashboardIndexesBmfCupomCambialParams,
 options?: SecondParameter<typeof customInstance<GetApiV1DashboardIndexesBmfCupomCambial200>>,) => {
      return customInstance<GetApiV1DashboardIndexesBmfCupomCambial200>(
      {url: `/api/v1/dashboard/indexes/bmf-cupom-cambial`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Este endpoint usa a fonte legada da antiga BMF, acessada via HTML em:
`https://www2.bmf.com.br/pages/portal/bmfbovespa/boletim1/TxRef1.asp`

Diferente dos endpoints modernos que consomem a API JSON da B3, este endpoint depende de scraping da p�gina legada `TxRef1.asp`.
Para `DI x pr�`, a fonte usa `slcTaxa=APR` (AjustePre) ou `slcTaxa=PRE` (Pre).

Links de refer�ncia:
- **AjustePre** (`APR`): `https://www2.bmf.com.br/pages/portal/bmfbovespa/boletim1/TxRef1.asp?slcTaxa=APR`
- **Pre** (`PRE`): `https://www2.bmf.com.br/pages/portal/bmfbovespa/boletim1/TxRef1.asp?slcTaxa=PRE`

Observa��o importante: essa fonte legada deixou de ser atualizada ap�s `09/04/2026`.
Por isso, para qualquer `referenceDate` posterior, o backend aplica fallback autom�tico para `09/04/2026`,
preservando o acesso � �ltima curva dispon�vel nessa origem.

A resposta inclui os dias corridos e os valores correspondentes para as bases 252 e 360.
 * @summary Obt�m os dados da curva "DI x pr�" da BMF para uma data de refer�ncia espec�fica.
 */
const getDashboardIndexesBmfDiPre = (
    params?: GetApiV1DashboardIndexesBmfDiPreParams,
 options?: SecondParameter<typeof customInstance<GetApiV1DashboardIndexesBmfDiPre200>>,) => {
      return customInstance<GetApiV1DashboardIndexesBmfDiPre200>(
      {url: `/api/v1/dashboard/indexes/bmf-di-pre`, method: 'GET',
        params
    },
      options);
    }
  /**
 * A resposta inclui os dois v�rtices da curva usados no c�lculo, o modo de interpola��o aplicado
e os fatores anual e di�rio equivalentes para facilitar a rastreabilidade do valor retornado.
 * @summary Obt�m a taxa anual interpolada da curva DI1 para uma data alvo.
 */
const getDashboardIndexesDi1CurveInterpolatedRate = (
    params?: GetApiV1DashboardIndexesDi1CurveInterpolatedRateParams,
 options?: SecondParameter<typeof customInstance<GetApiV1DashboardIndexesDi1CurveInterpolatedRate200>>,) => {
      return customInstance<GetApiV1DashboardIndexesDi1CurveInterpolatedRate200>(
      {url: `/api/v1/dashboard/indexes/di1-curve/interpolated-rate`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Este endpoint interpola a curva da fonte legada da antiga BMF para `DI x pr�`,
cuja origem � a p�gina HTML:
`https://www2.bmf.com.br/pages/portal/bmfbovespa/boletim1/TxRef1.asp?slcTaxa=APR`

Diferente dos endpoints modernos que consomem a API JSON da B3, este endpoint depende da p�gina legada `TxRef1.asp`.

Observa��o importante: essa fonte legada deixou de ser atualizada ap�s `09/04/2026`.
Por isso, quando a `referenceDate` for posterior a essa data, o backend usa automaticamente a �ltima curva dispon�vel em `09/04/2026`.

O endpoint usa a curva DI x pr� da BMF na data-base D-1 �til da `referenceDate`,
conta os dias �teis at� `targetDate`, interpola linearmente a taxa anual equivalente
e exp�e os pontos da curva usados no c�lculo, al�m dos fatores equivalentes.
 * @summary Obt�m a taxa DI anual interpolada da curva BMF para uma data alvo.
 */
const getDashboardIndexesBmfDiPreInterpolatedRate = (
    params?: GetApiV1DashboardIndexesBmfDiPreInterpolatedRateParams,
 options?: SecondParameter<typeof customInstance<GetApiV1DashboardIndexesBmfDiPreInterpolatedRate200>>,) => {
      return customInstance<GetApiV1DashboardIndexesBmfDiPreInterpolatedRate200>(
      {url: `/api/v1/dashboard/indexes/bmf-di-pre/interpolated-rate`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Este endpoint usa a fonte legada da antiga BMF, acessada via HTML em:
`https://www2.bmf.com.br/pages/portal/bmfbovespa/boletim1/TxRef1.asp?slcTaxa=DP`

Diferente dos endpoints modernos que consomem a API JSON da B3, este endpoint depende de scraping da p�gina legada `TxRef1.asp`.

Observa��o importante: essa fonte legada deixou de ser atualizada ap�s `09/04/2026`.
Por isso, para qualquer `referenceDate` posterior, o backend aplica fallback autom�tico para `09/04/2026`,
preservando o acesso � �ltima curva dispon�vel nessa origem.

A resposta inclui os dias corridos e os valores correspondentes para as bases 252 e 360.
 * @summary Obt�m os dados da curva "D�lar x pr�" da BMF para uma data de refer�ncia espec�fica.
 */
const getDashboardIndexesBmfDolarXPre = (
    params?: GetApiV1DashboardIndexesBmfDolarXPreParams,
 options?: SecondParameter<typeof customInstance<GetApiV1DashboardIndexesBmfDolarXPre200>>,) => {
      return customInstance<GetApiV1DashboardIndexesBmfDolarXPre200>(
      {url: `/api/v1/dashboard/indexes/bmf-dolar-x-pre`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Este endpoint usa a fonte legada da antiga BMF, acessada via HTML em:
`https://www2.bmf.com.br/pages/portal/bmfbovespa/boletim1/TxRef1.asp?slcTaxa=DIC`

Diferente dos endpoints modernos que consomem a API JSON da B3, este endpoint depende de scraping da p�gina legada `TxRef1.asp`.

Observa��o importante: essa fonte legada deixou de ser atualizada ap�s `09/04/2026`.
Por isso, para qualquer `referenceDate` posterior, o backend aplica fallback autom�tico para `09/04/2026`,
preservando o acesso � �ltima curva dispon�vel nessa origem.

A resposta inclui os dias corridos e os valores correspondentes apenas para a base 252 (o Value360 ser� 0).
 * @summary Obt�m os dados da curva "DI vs IPCA" (DIC) da BMF para uma data de refer�ncia espec�fica.
 */
const getDashboardIndexesBmfDiVsIpca = (
    params?: GetApiV1DashboardIndexesBmfDiVsIpcaParams,
 options?: SecondParameter<typeof customInstance<GetApiV1DashboardIndexesBmfDiVsIpca200>>,) => {
      return customInstance<GetApiV1DashboardIndexesBmfDiVsIpca200>(
      {url: `/api/v1/dashboard/indexes/bmf-di-vs-ipca`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Este endpoint interpola a curva da fonte legada da antiga BMF para `DI vs IPCA`,
cuja origem � a p�gina HTML:
`https://www2.bmf.com.br/pages/portal/bmfbovespa/boletim1/TxRef1.asp?slcTaxa=DIC`

Diferente dos endpoints modernos que consomem a API JSON da B3, este endpoint depende da p�gina legada `TxRef1.asp`.

Observa��o importante: essa fonte legada deixou de ser atualizada ap�s `09/04/2026`.
Por isso, quando a `referenceDate` for posterior a essa data, o backend usa automaticamente a �ltima curva dispon�vel em `09/04/2026`.

Reutiliza o mesmo algoritmo de interpola��o linear da curva DI x pr�, alterando apenas a origem dos pontos para `DI vs IPCA`,
e exp�e os pontos da curva usados no c�lculo, al�m dos fatores equivalentes.
 * @summary Obt�m a taxa anual interpolada da curva DI vs IPCA da BMF para uma data alvo.
 */
const getDashboardIndexesBmfDiVsIpcaInterpolatedRate = (
    params?: GetApiV1DashboardIndexesBmfDiVsIpcaInterpolatedRateParams,
 options?: SecondParameter<typeof customInstance<GetApiV1DashboardIndexesBmfDiVsIpcaInterpolatedRate200>>,) => {
      return customInstance<GetApiV1DashboardIndexesBmfDiVsIpcaInterpolatedRate200>(
      {url: `/api/v1/dashboard/indexes/bmf-di-vs-ipca/interpolated-rate`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Mantido por compatibilidade. Para novas integrações, use `GET /api/v1/dollar-volatility-surface`.
 * @summary Obt�m os dados da Superf�cie de Volatilidade de D�lar da B3.
 */
const getDashboardIndexesDollarVolatilitySurface = (
    params?: GetApiV1DashboardIndexesDollarVolatilitySurfaceParams,
 options?: SecondParameter<typeof customInstance<GetApiV1DashboardIndexesDollarVolatilitySurface200>>,) => {
      return customInstance<GetApiV1DashboardIndexesDollarVolatilitySurface200>(
      {url: `/api/v1/dashboard/indexes/dollar-volatility-surface`, method: 'GET',
        params
    },
      options);
    }
  /**
 * A curva impl�cita de IPCA � derivada da rela��o entre a curva DI1 (pr�-fixada) e a curva DAP (Cupom de IPCA).
A f�rmula utilizada �:
`IPCA_impl�cito = ((1 + DI1_rate/100) / (1 + DAP_rate/100) - 1) � 100`

Esta curva permite extrair a expectativa de infla��o impl�cita no mercado a partir dos contratos de derivativos da B3.

O endpoint consome os dados das curvas DI1 e DAP da API oficial da B3:
- DI1: `https://cotacao.b3.com.br/mds/api/v1/DerivativeQuotation/DI1`
- DAP: `https://cotacao.b3.com.br/mds/api/v1/DerivativeQuotation/DAP`

Os pontos da curva s�o retornados apenas para as datas de vencimento comuns entre DI1 e DAP.
 * @summary Obt�m a curva impl�cita de IPCA calculada a partir das curvas DI1 e DAP.
 */
const getDashboardIndexesImplicitIpcaCurve = (
    params?: GetApiV1DashboardIndexesImplicitIpcaCurveParams,
 options?: SecondParameter<typeof customInstance<GetApiV1DashboardIndexesImplicitIpcaCurve200>>,) => {
      return customInstance<GetApiV1DashboardIndexesImplicitIpcaCurve200>(
      {url: `/api/v1/dashboard/indexes/implicit-ipca-curve`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Replica exatamente a planilha Termo.xlsx. Para cada perna (inicial e final), calcula
dias �teis (DU) e dias corridos (DC) de hoje at� a data. Em seguida aplica:

  FatorTermo    = ((1 + taxaFinal/100)^(DUfinal/252)) / ((1 + taxaInicial/100)^(DUinicial/252))
  TermoAoPeriodo = FatorTermo - 1
  TermoAoAno     = FatorTermo^(252/(DUfinal - DUinicial)) - 1

Se as datas n�o existirem exatamente na curva escolhida, o servi�o aplica interpola��o
linear entre os v�rtices adjacentes dispon�veis (mesmo mecanismo dos demais endpoints
de taxa interpolada do dashboard).

Curvas dispon�veis: Di1, Dap, DiXPre, ImplicitIpca, Ddi, Dol, Eur.
 * @summary Calcula o Termo entre duas datas para uma curva de mercado selecionada.
 */
const getDashboardIndexesForward = (
    params?: GetApiV1DashboardIndexesForwardParams,
 options?: SecondParameter<typeof customInstance<GetApiV1DashboardIndexesForward200>>,) => {
      return customInstance<GetApiV1DashboardIndexesForward200>(
      {url: `/api/v1/dashboard/indexes/forward`, method: 'GET',
        params
    },
      options);
    }
  /**
 * A curva impl�cita de IPCA � derivada da rela��o entre a curva DI1 (pr�-fixada) e a curva DAP (Cupom de IPCA).
A f�rmula utilizada �:
`IPCA_impl�cito = ((1 + DI1_rate/100) / (1 + DAP_rate/100) - 1) � 100`

A resposta inclui os dois v�rtices da curva usados no c�lculo, o modo de interpola��o aplicado
e os fatores anual e di�rio equivalentes para facilitar a rastreabilidade do valor retornado.
A interpola��o � feita sobre o `ImplicitIpcaRate` dos pontos, usando `MaturityDate` como eixo da curva.
 * @summary Obt�m a taxa anual interpolada da curva impl�cita de IPCA para uma data alvo.
 */
const getDashboardIndexesImplicitIpcaCurveInterpolatedRate = (
    params?: GetApiV1DashboardIndexesImplicitIpcaCurveInterpolatedRateParams,
 options?: SecondParameter<typeof customInstance<GetApiV1DashboardIndexesImplicitIpcaCurveInterpolatedRate200>>,) => {
      return customInstance<GetApiV1DashboardIndexesImplicitIpcaCurveInterpolatedRate200>(
      {url: `/api/v1/dashboard/indexes/implicit-ipca-curve/interpolated-rate`, method: 'GET',
        params
    },
      options);
    }
  /**
 * O endpoint retorna dados cacheados no Redis e, quando `forceUpdate=true` ou quando o cache ainda nao existe,
consulta as fontes oficiais para renovar o cache.

Fontes e composicao dos dados:
- IBGE/SIDRA: IPCA 12M, PIB acumulado em 4 trimestres, producao industrial, desemprego,
  rendimento medio real, massa de rendimento real e vendas no varejo.
- Banco Central do Brasil/SGS: Selic meta, IGP-M 12M, IBC-Br, resultado primario,
  divida bruta e inadimplencia de credito.
- Banco Central do Brasil/Focus: mediana anual esperada de IPCA e Selic para o ano corrente.
- Banco Central do Brasil/Copom: ultima ata, ultimo comunicado, reunioes do ano e proximas publicacoes
  de atas e comunicados, usando a API de documentos do Copom e o calendario oficial do BC.
- Banco Central do Brasil/Focus: expectativas anuais detalhadas de IPCA, cambio, PIB e Selic,
  com data de pesquisa, data de divulgacao, quantidade de respondentes e calendario oficial de divulgacoes do Focus.
- Modo estendido (`Extended`): poupanca, reservas internacionais, risco-pais EMBI+ Brasil via Ipeadata,
  transacoes correntes, investimento direto, balanca comercial BP, resultado nominal, juros nominais,
  divida liquida, concessoes de credito, spread, IPCA por grupo, IPCA-15, PMS, PMC, producao industrial
  por categoria e cambio Focus para quatro anos.

A atualizacao e resiliente por indicador: se uma fonte falhar, os demais indicadores continuam sendo
atualizados. O item com falha retorna `Status = Stale` quando havia valor anterior no Redis, ou
`Status = Failed` quando ainda nao existe dado cacheado. As secoes `Copom`, `Focus` e `Extended` seguem a mesma regra de status.
`LastSuccessfulUpdateAtGmt` registra em GMT a ultima atualizacao efetiva geral, por indicador e por secao.
 * @summary Obtem os indicadores-chave macroeconomicos oficiais usados no dashboard.
 */
const getDashboardKeyIndicators = (
    params?: GetApiV1DashboardKeyIndicatorsParams,
 options?: SecondParameter<typeof customInstance<GetApiV1DashboardKeyIndicators200>>,) => {
      return customInstance<GetApiV1DashboardKeyIndicators200>(
      {url: `/api/v1/dashboard/key-indicators`, method: 'GET',
        params
    },
      options);
    }
  return {getDashboardAvailableVsContractedCredit,getDashboardIndexesCdiDailyAnnualizedCurrent,getDashboardIndexesCdiDailyCurrent,getDashboardIndexesCdiDaily,getDashboardIndexesSofrCurrent,getDashboardIndexesIpcaMonthCurrent,getDashboardIndexesIpcaMonth,getDashboardIndexesCurrencyExchangeCurrent,getDashboardCalendar,getDashboardDerivativeIndex,getDashboardEconomicCalendar,getDashboardCurrencyQuotesAll,getDashboardIndexesDi1Curve,getDashboardIndexesDdiCurve,getDashboardIndexesDapCurve,getDashboardIndexesEurCurve,getDashboardIndexesDolCurve,getDashboardIndexesDdiCurveInterpolatedRate,getDashboardIndexesDolCurveInterpolatedRate,getDashboardIndexesDapCurveInterpolatedRate,getDashboardIndexesEurCurveInterpolatedRate,getDashboardPtaxCurveLast60Days,getDashboardIndexesBmfCupomCambial,getDashboardIndexesBmfDiPre,getDashboardIndexesDi1CurveInterpolatedRate,getDashboardIndexesBmfDiPreInterpolatedRate,getDashboardIndexesBmfDolarXPre,getDashboardIndexesBmfDiVsIpca,getDashboardIndexesBmfDiVsIpcaInterpolatedRate,getDashboardIndexesDollarVolatilitySurface,getDashboardIndexesImplicitIpcaCurve,getDashboardIndexesForward,getDashboardIndexesImplicitIpcaCurveInterpolatedRate,getDashboardKeyIndicators}};
export type GetApiV1DashboardAvailableVsContractedCreditResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardAvailableVsContractedCredit']>>>
export type GetApiV1DashboardIndexesCdiDailyAnnualizedCurrentResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardIndexesCdiDailyAnnualizedCurrent']>>>
export type GetApiV1DashboardIndexesCdiDailyCurrentResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardIndexesCdiDailyCurrent']>>>
export type GetApiV1DashboardIndexesCdiDailyResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardIndexesCdiDaily']>>>
export type GetApiV1DashboardIndexesSofrCurrentResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardIndexesSofrCurrent']>>>
export type GetApiV1DashboardIndexesIpcaMonthCurrentResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardIndexesIpcaMonthCurrent']>>>
export type GetApiV1DashboardIndexesIpcaMonthResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardIndexesIpcaMonth']>>>
export type GetApiV1DashboardIndexesCurrencyExchangeCurrentResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardIndexesCurrencyExchangeCurrent']>>>
export type GetApiV1DashboardCalendarResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardCalendar']>>>
export type GetApiV1DashboardDerivativeIndexResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardDerivativeIndex']>>>
export type GetApiV1DashboardEconomicCalendarResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardEconomicCalendar']>>>
export type GetApiV1DashboardCurrencyQuotesAllResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardCurrencyQuotesAll']>>>
export type GetApiV1DashboardIndexesDi1CurveResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardIndexesDi1Curve']>>>
export type GetApiV1DashboardIndexesDdiCurveResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardIndexesDdiCurve']>>>
export type GetApiV1DashboardIndexesDapCurveResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardIndexesDapCurve']>>>
export type GetApiV1DashboardIndexesEurCurveResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardIndexesEurCurve']>>>
export type GetApiV1DashboardIndexesDolCurveResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardIndexesDolCurve']>>>
export type GetApiV1DashboardIndexesDdiCurveInterpolatedRateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardIndexesDdiCurveInterpolatedRate']>>>
export type GetApiV1DashboardIndexesDolCurveInterpolatedRateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardIndexesDolCurveInterpolatedRate']>>>
export type GetApiV1DashboardIndexesDapCurveInterpolatedRateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardIndexesDapCurveInterpolatedRate']>>>
export type GetApiV1DashboardIndexesEurCurveInterpolatedRateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardIndexesEurCurveInterpolatedRate']>>>
export type GetApiV1DashboardPtaxCurveLast60DaysResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardPtaxCurveLast60Days']>>>
export type GetApiV1DashboardIndexesBmfCupomCambialResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardIndexesBmfCupomCambial']>>>
export type GetApiV1DashboardIndexesBmfDiPreResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardIndexesBmfDiPre']>>>
export type GetApiV1DashboardIndexesDi1CurveInterpolatedRateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardIndexesDi1CurveInterpolatedRate']>>>
export type GetApiV1DashboardIndexesBmfDiPreInterpolatedRateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardIndexesBmfDiPreInterpolatedRate']>>>
export type GetApiV1DashboardIndexesBmfDolarXPreResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardIndexesBmfDolarXPre']>>>
export type GetApiV1DashboardIndexesBmfDiVsIpcaResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardIndexesBmfDiVsIpca']>>>
export type GetApiV1DashboardIndexesBmfDiVsIpcaInterpolatedRateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardIndexesBmfDiVsIpcaInterpolatedRate']>>>
export type GetApiV1DashboardIndexesDollarVolatilitySurfaceResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardIndexesDollarVolatilitySurface']>>>
export type GetApiV1DashboardIndexesImplicitIpcaCurveResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardIndexesImplicitIpcaCurve']>>>
export type GetApiV1DashboardIndexesForwardResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardIndexesForward']>>>
export type GetApiV1DashboardIndexesImplicitIpcaCurveInterpolatedRateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardIndexesImplicitIpcaCurveInterpolatedRate']>>>
export type GetApiV1DashboardKeyIndicatorsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDashboard>['getDashboardKeyIndicators']>>>
